module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/175.5bef8eba.png";